import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BootstrapButton, BootstrapIcon, BootstrapLink, DocumentType } from '../../../../dsl/front';
/**
 * Component capable to render the `EmbedModule`
 * with the version set `EmbedVersion.Pdf`
 *
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
let EmbedPdfUi = class EmbedPdfUi extends Vue {
    constructor() {
        super(...arguments);
        /**
         * Resolved pdf file
         */
        this.resolvedFile = null;
    }
    /**
     * Downloads resolved pdf
     */
    async downloadPdf() {
        if (!this.pdfService || !this.resolvedFile) {
            console.warn('EmbedPdf.ui: Missing prop [pdfService]');
            return;
        }
        await this.pdfService.downland({
            path: this.resolvedFile.fileUrl,
            public: true
        });
    }
    /**
     * @inheritDoc
     */
    async fetchRelated() {
        await this.resolveFile();
    }
    /**
     * Resolves the pdf file, if any.
     */
    async resolveFile() {
        if (typeof this.pdf === 'undefined') {
            return;
        }
        let file = {};
        try {
            file = await this.relatedService.resolve(this.pdf);
        }
        catch (e) {
            console.warn(e);
            return;
        }
        this.resolvedFile = {
            type: DocumentType.PDF,
            fileDescription: file.title || file.caption || file.alt,
            fileUrl: file.url
        };
    }
};
__decorate([
    Prop({ type: String, required: false })
], EmbedPdfUi.prototype, "description", void 0);
__decorate([
    Prop({ type: Object, required: false })
], EmbedPdfUi.prototype, "pdf", void 0);
__decorate([
    Prop({ type: Object, required: false, default: null })
], EmbedPdfUi.prototype, "pdfService", void 0);
__decorate([
    Prop({ type: Boolean, required: false })
], EmbedPdfUi.prototype, "pdfAsLink", void 0);
__decorate([
    Prop({ type: Object, required: true })
], EmbedPdfUi.prototype, "relatedService", void 0);
EmbedPdfUi = __decorate([
    Component({
        name: 'EmbedPdfUi',
        components: {
            BootstrapLink,
            BootstrapButton,
            BootstrapIcon
        },
        async created() {
            await this.fetchRelated();
        },
        mounted() {
            this.$emit('ready');
        },
        template: `
    <!--<figure v-if="!pdfAsLink" class="embed-pdf">-->
    <!--  NOTICE!: This package has been removed due to SSR compatibility -->
    <!--  <pdf v-if="resolvedFile" :src="resolvedFile.fileUrl"></pdf>-->
    <!--  <figcaption v-if="description" class="small">-->
    <!--    {{ description }}-->
    <!--  </figcaption>-->
    <!--</figure>-->
    <figure>
      <BootstrapButton v-if="resolvedFile" class="article-action btn-link p-0" @click="downloadPdf">
        <BootstrapIcon name="download" size="small" class="article-action__icon me-1" />
           {{ this.resolvedFile.fileDescription }} [{{ $t('_.downloadPdf') }}]
        </BootstrapButton>
      <figcaption v-if="description" class="small">
        {{ description }}
      </figcaption>
    </figure>
  `
    })
], EmbedPdfUi);
export { EmbedPdfUi };
export default EmbedPdfUi;
